import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/color.css';
import './styles/styles-global.css';
import './styles/fix-styles.css';
// NMU-522: the notification palette. Last, so it wins over antd's own card.
import './styles/notification-cards.css';

import React, { useState, useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import configStore from './config/redux-store-config';

import AppRouteContainer from './route';
import validateMessages from './constants/validate-messages';

const App = () => {

  const [storagePersisted, setStoragePersisted] = useState(false);
  const [store, setStore] = useState(null);
  const [persistor, setPersistor] = useState(null);

  useEffect(() => {
    const { store, persistor } = configStore(() => {
      setStoragePersisted(true);
    });
    setStore(store);
    setPersistor(persistor);
  }, []);

  if (!storagePersisted) {
    return null;
  }

  return (
    /*
      NMU-532: the admin's validation wording, applied once for every form.

      Set here rather than form by form so a page inherits it by existing. The
      previous arrangement — each dialog passing its own `validateMessages` —
      is exactly how thirteen forms ended up all saying "โปรดระบุ" and a
      fourteenth saying nothing at all (antd's English default).
    */
    <ConfigProvider form={{ validateMessages }}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRouteContainer />
        </PersistGate>
      </Provider>
    </ConfigProvider>
  )

}

export default App;